// P5 Assessment Types
export const GET_PBL_P5 = 'GET_PBL_P5';
export const GET_PBL_P5_SUCCESS = 'GET_PBL_P5_SUCCESS';
export const GET_PBL_P5_FAILURE = 'GET_PBL_P5_FAILURE';

// Project Types
export const GET_PBL_PROJECT_TYPES = 'GET_PBL_PROJECT_TYPES';
export const GET_PBL_PROJECT_TYPES_SUCCESS = 'GET_PBL_PROJECT_TYPES_SUCCESS';
export const GET_PBL_PROJECT_TYPES_FAILURE = 'GET_PBL_PROJECT_TYPES_FAILURE';

// Projects
export const GET_PBL_PROJECTS = 'GET_PBL_PROJECTS';
export const GET_PBL_PROJECTS_SUCCESS = 'GET_PBL_PROJECTS_SUCCESS';
export const GET_PBL_PROJECTS_FAILURE = 'GET_PBL_PROJECTS_FAILURE';

export const GET_PBL_PROJECTS_ID = 'GET_PBL_ID_PROJECTS';
export const GET_PBL_PROJECTS_ID_SUCCESS = 'GET_PBL_ID_PROJECTS_SUCCESS';
export const GET_PBL_PROJECTS_ID_FAILURE = 'GET_PBL_ID_PROJECTS_FAILURE';

export const CREATE_PBL_PROJECT = 'CREATE_PBL_PROJECT';
export const CREATE_PBL_PROJECT_SUCCESS = 'CREATE_PBL_PROJECT_SUCCESS';
export const CREATE_PBL_PROJECT_FAILURE = 'CREATE_PBL_PROJECT_FAILURE';

// Update Project
export const UPDATE_PBL_PROJECT = 'UPDATE_PBL_PROJECT';
export const UPDATE_PBL_PROJECT_SUCCESS = 'UPDATE_PBL_PROJECT_SUCCESS';
export const UPDATE_PBL_PROJECT_FAILURE = 'UPDATE_PBL_PROJECT_FAILURE';

// Validate Project Availability
export const VALIDATE_PROJECT_AVAILABILITY = 'VALIDATE_PROJECT_AVAILABILITY';
export const VALIDATE_PROJECT_AVAILABILITY_SUCCESS = 'VALIDATE_PROJECT_AVAILABILITY_SUCCESS';
export const VALIDATE_PROJECT_AVAILABILITY_FAILURE = 'VALIDATE_PROJECT_AVAILABILITY_FAILURE';

// Class Courses
export const GET_CLASS_COURSES = 'GET_CLASS_COURSES';
export const GET_CLASS_COURSES_SUCCESS = 'GET_CLASS_COURSES_SUCCESS';
export const GET_CLASS_COURSES_FAILURE = 'GET_CLASS_COURSES_FAILURE';

// Course Teachers
export const GET_COURSE_TEACHERS = 'GET_COURSE_TEACHERS';
export const GET_COURSE_TEACHERS_SUCCESS = 'GET_COURSE_TEACHERS_SUCCESS';
export const GET_COURSE_TEACHERS_FAILURE = 'GET_COURSE_TEACHERS_FAILURE';
